<template>
  <el-dialog :title="title" :visible="visible" @close="closeDialog">
    <span slot="footer" class="dialog-footer">
      <avue-form :option="qcFormOption" v-model="qcForm" ref="qcForm">
        <template slot="menuForm">
          <el-button icon="el-icon-check" type="primary" @click="submit">
            发送
          </el-button>
        </template>
      </avue-form>
    </span>
  </el-dialog>
</template>

<script>
import { qcFormOption } from '@/const/crud/qc/qcflow';
import { addQcMessage } from '@/api/dot/qc';

export default {
  name: 'QcMessageDialog',
  props: [
    'orderId',
    'trId',
    'userInfo',
    'visible',
    'name', // 质控用户名
  ],
  data: () => {
    return {
      qcFormOption: qcFormOption,
      qcForm: {},
    };
  },
  computed: {
    // 标题
    title() {
      return this.name ? `质控留言@${this.name}` : '质控留言';
    },
  },
  methods: {
    // 提交留言
    submit() {
      if (!this.qcForm.remark?.trim()) {
        return;
      }
      addQcMessage({
        orderId: this.orderId,
        trId: this.trId,
        qcId: this.userInfo.staffId,
        message: this.qcForm.remark,
      }).then((res) => {
        if (res?.data?.data === 1) {
          this.closeDialog();
          this.$refs.qcForm.resetForm();
          this.$message.success('提交成功');
        } else {
          this.$message.error('提交失败');
        }
      });
    },
    // 关闭弹窗
    closeDialog() {
      this.$emit('update:visible', false);
    },
  },
};
</script>
